import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Draggable } from 'react-beautiful-dnd';
import Icon from '../Global/Icons/Icon';
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';
import OwnerText from '../Global/Conversions/OwnerText';

const FolderListItem = ({ index, folder, active, onClick, itemMoved }) => {
  const draggableId = `folder-${folder.id.toString()}`;
  return (
    <Draggable draggableId={draggableId} index={index} isDragDisabled={!folder.owned_by_me}>
      {(provided, snapshot) => {
        // hide the item while we display a confirmation modal
        if (itemMoved === draggableId) return null;

        const listClass = classNames({
          'bg-green--light': folder.new && !snapshot.isDragging,
          'bg-grey--bg': active && !snapshot.isDragging,
          'content-list-new__list-item--dragging': snapshot.isDragging,
          'content-list-new__list-item--dragging-delete': snapshot.isDragging && snapshot.draggingOver === `delete`,
        });

        const iconName = folder.shared ? `folder-shared` : `folder`;
        const iconFill = folder.owned_by_me ? `blue` : `black`;

        return (
          <li
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={listClass}
          >
            {/* Unfortunately has to be a link instead of a button to work with Draggable https://github.com/atlassian/react-beautiful-dnd#interactive-child-elements-within-a-draggable */}
            <a role="button" tabIndex={0} onClick={onClick}>
              <div className="d-flex">
                <Icon name={iconName} fill={iconFill} size="m"/>
              </div>

              <VerticalTextLockup
                title={<h3 className="like-p">{folder.title}</h3>}
                subtitle={<div className="like-small"><OwnerText owner={folder.owned_by_me}/></div>}
              />

              <div className="d-flex">
                <Icon name="arrow-right" size="m"/>
              </div>
            </a>
          </li>
        );
      }}
    </Draggable>
  );
};

FolderListItem.propTypes = {
  index: PropTypes.number.isRequired,
  folder: PropTypes.object.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  itemMoved: PropTypes.string,
};

export default FolderListItem;



// WEBPACK FOOTER //
// ./library/app/components/Folders/FolderListItem.js